import { getSnapShotIndexesAction, getSnapShotIndexesInfoAction, StoreMarketIndexes, StoreMarketIndexesInfo } from "@/stores/dataManager/Actions/marketIndexAction"
import { useAppSelector } from "@/stores/dataStore/reduxStore/hook";

export const useMarketIndexes = () => {
    try {
        const history = useAppSelector(StoreMarketIndexes)
        return {
            history
        };
    } catch (e) {
        return {
            history: {},
        };
    }
}

export const useMarketIndexesInfo = () => {
    try {
        const marketInfo = useAppSelector(StoreMarketIndexesInfo)
        return {
            marketInfo
        };
    } catch (e) {
        return {
            marketInfo: {},
        };
    }
}

export const getSnapShotIndexesInfoManager = () => {
    const getSnapShotIndexesInfoManagerCallAction = () => {
        try {
            return getSnapShotIndexesInfoAction()
        } catch (e) {
            return () => { }
        }
    }
    return { getSnapShotIndexesInfoManagerCallAction }
}

export const getSnapShotIndexesManager = () => {
    const getSnapShotIndexesManagerCallAction = () => {
        try {
            return getSnapShotIndexesAction()
        } catch (e) {
            return () => { }
        }
    }
    return { getSnapShotIndexesManagerCallAction }
}